import Preact from 'preact';

var FormStructure = {
    fields: {
        headerLabel: {
            validations: []
        },
        FirstName: {
            validations: [
                { type: 'required', message: 'Please fill in required field.' }
            ]
        },
        LastName: {
            validations: [
                { type: 'required', message: 'Please fill in required field.' }
            ]
        },
        ClientName: {
            validations: []
        },
        EventDate: {
            validations: [
                { type: 'required', message: 'Please fill in required field.' },
                { type: 'dateinfuture', message: 'Event date must be in the future.' }
            ]
        },
        AddressLine1: {
            validations: [
                { type: 'required', message: 'Please fill in required field.' }
            ]
        },
        City: {
            validations: [
                { type: 'required', message: 'Please fill in required field.' }
            ]
        },
        State: {
            validations: [
                { type: 'required', message: 'Please fill in required field.' }
            ]
        },
        Postal: {
            validations: [
                { type: 'maxLength', maxLength: 5, message: 'Enter 5 digit zip code' },
                { type: 'required', message: 'Please fill in required field.' }
            ]
        },
        Email: {
            validations: [
                { type: 'required', message: 'Please fill in required field.' },
                { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' }
            ]
        },
        TelNumber: {
            validations: [
                { type: 'required', message: 'Please fill in required field.' },
                { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' }
            ]
        },
        CellNumber: {
          validations: [
            { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' },
            { type: 'required', message: 'Please fill in required field.' }
          ]
        },
        PaymentMethod: {
          validations: [
            { type: 'required', message: 'Please fill in required field.' }
          ]
        },
        Reference: {
          validations: [
            { type: 'required', message: 'Please fill in required field.' }
          ]
        },
        Operation: {
          validations: [
            { type: 'required', message: 'Please fill in required field.' },
          ]
        },
        StartTime: {
          validations: [
            { type: 'required', message: 'Please fill in required field.' }
          ]
        }, 
        EndTime: {
          validations: [
            { type: 'required', message: 'Please fill in required field.' }
          ]
        },
        PlannedGuestCount: {
            validations: [
                { type: 'regex', pattern: '^[0-9]*$', message: 'Please provide in numbers only.' },
                { type: 'required', message: 'Please fill in required field.' }
            ]
        },
        Category: {
          validations: [
            { type: 'required', message: 'Please fill in required field.' }
          ]
        },
        EventExtra1: {
            validations: [
                { type: 'required', message: 'Please fill in required field.' }
            ]
        },
        EventExtra2: {
            validations: []
        },
        SiteName: {
          validations: [
            { type: 'required', message: 'Please fill in required field.' },
          ]
        },
        SiteAddress: {
          validations: [
            { type: 'required', message: 'Please fill in required field.' },
          ]
        },
        SiteCity: {
            validations: [
                { type: 'required', message: 'Please fill in required field.' }
            ]
        },
        SiteState: {
            validations: [
                { type: 'required', message: 'Please fill in required field.' }
            ]
        },
        SitePostal: {
            validations: [
                { type: 'maxLength', maxLength: 5, message: 'Enter 5 digit zip code' },
                { type: 'required', message: 'Please fill in required field.' }
            ]
        },
        EventExtra3: {
            validations: [
                { type: 'required', message: 'Please fill in required field.' }
            ]
        },
        EventExtra4: {
            validations: []
        },
        EventExtra5: {
            validations: [
                { type: 'required', message: 'Please fill in required field.' }
            ]
        },
        EventExtra6: {
            validations: [
                { type: 'required', message: 'Please fill in required field.' }
            ]
        },
        EventExtra7: {
            validations: [
                { type: 'required', message: 'Please fill in required field.' }
            ]
        },
        Notes: {
            validations: []
        }
    },
    layout: {
        rows: [
            {
                fields: [
                    {
                    type: 'text',
                    size: 'Medium',
                    label: 'First Name:*',
                    mapping: 'FirstName'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'text',
                    size: 'Medium',
                    label: 'Last Name:*',
                    mapping: 'LastName'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'text',
                    size: 'Medium',
                    label: 'Business:',
                    mapping: 'ClientName'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'date-picker-nofill',
                    size: 'Medium',
                    label: 'Date of Event:*',
                    mapping: 'EventDate'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'text',
                    size: 'Medium',
                    label: 'Billing Address:*',
                    mapping: 'AddressLine1'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'text',
                    size: 'Medium',
                    label: 'Billing City:*',
                    mapping: 'City'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'multiple-choice',
                    size: 'Medium',
                    label: 'Billing State:*',
                    options: [
                        { label: 'AL', value: 'AL' },
                        { label: 'AK', value: 'AK' },
                        { label: 'AZ', value: 'AZ' },
                        { label: 'AR', value: 'AR' },
                        { label: 'CA', value: 'CA' },
                        { label: 'CO', value: 'CO' },
                        { label: 'CT', value: 'CT' },
                        { label: 'DE', value: 'DE' },
                        { label: 'DC', value: 'DC' },
                        { label: 'FL', value: 'FL' },
                        { label: 'GA', value: 'GA' },
                        { label: 'HI', value: 'HI' },
                        { label: 'ID', value: 'ID' },
                        { label: 'IL', value: 'IL' },
                        { label: 'IN', value: 'IN' },
                        { label: 'IA', value: 'IA' },
                        { label: 'KS', value: 'KS' },
                        { label: 'KY', value: 'KY' },
                        { label: 'LA', value: 'LA' },
                        { label: 'ME', value: 'ME' },
                        { label: 'MD', value: 'MD' },
                        { label: 'MA', value: 'MA' },
                        { label: 'MI', value: 'MI' },
                        { label: 'MN', value: 'MN' },
                        { label: 'MS', value: 'MS' },
                        { label: 'MO', value: 'MO' },
                        { label: 'MT', value: 'MT' },
                        { label: 'NE', value: 'NE' },
                        { label: 'NV', value: 'NV' },
                        { label: 'NH', value: 'NH' },
                        { label: 'NJ', value: 'NJ' },
                        { label: 'NM', value: 'NM' },
                        { label: 'NY', value: 'NY' },
                        { label: 'NC', value: 'NC' },
                        { label: 'ND', value: 'ND' },
                        { label: 'OH', value: 'OH' },
                        { label: 'OK', value: 'OK' },
                        { label: 'OR', value: 'OR' },
                        { label: 'PA', value: 'PA' },
                        { label: 'RI', value: 'RI' },
                        { label: 'SC', value: 'SC' },
                        { label: 'SD', value: 'SD' },
                        { label: 'TN', value: 'TN' },
                        { label: 'TX', value: 'TX' },
                        { label: 'UT', value: 'UT' },
                        { label: 'VT', value: 'VT' },
                        { label: 'VA', value: 'VA' },
                        { label: 'WA', value: 'WA' },
                        { label: 'WV', value: 'WV' },
                        { label: 'WI', value: 'WI' },
                        { label: 'WY', value: 'WY' }
                    ],
                    mapping: 'State'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'text',
                    size: 'Medium',
                    label: 'Billing Postal:*',
                    mapping: 'Postal'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'text',
                    size: 'Medium',
                    label: 'Email Address:*',
                    mapping: 'Email'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'text',
                    size: 'Medium',
                    label: 'Phone Number:*',
                    mapping: 'TelNumber'
                }
            ]
            },
            {
                fields: [
                    {
                type: 'text',
                size: 'Medium',
                label: 'Back-up Number:*',
                mapping: 'CellNumber'
              }
            ]
          },
          {
            fields: [
              {
                type: 'multiple-choice',
                size: 'Medium',
                label: 'Billing Preference:*',
                options: [
                    { label: 'Credit Card', value: 'Credit Card' },
                    { label: 'Direct Bill', value: 'Direct Bill' },
                ],
                mapping: 'PaymentMethod'
              }
            ]
          },
          {
            fields: [
              {
                type: 'multiple-choice',
                size: 'Medium',
                label: 'How did you hear about Elephants Catering?:*',
                options: [
                    { label: 'Direct Referral', value: 'Direct Referral' },
                    { label: 'Web Search', value: 'Web Search' },
                    { label: 'Repeat Client', value: 'Repeat Client' },
                    { label: 'Other', value: 'Other' },
                ],
                mapping: 'Reference'
              }
            ]
          },
          {
            fields: [
                {
                type: 'multiple-choice',
                size: 'Medium',
                label: 'Type of Catering Requested:*',
                options: [
                    { label: 'Catering Delivery', value: 'Catering Delivery' },
                    { label: 'Catering Pick-up', value: 'Catering Pick-up' },
                    { label: 'Catering Full-Service', value: 'Catering Full-Service' },
                    { label: 'Not Sure', value: 'Not Sure' },
                ],
                mapping: 'Operation'
              }
            ]
          },
          {
            fields: [
              {
                type: 'multiple-choice',
                size: 'Medium',
                label: 'Time Event Starts:*',
                options: [
                  { label: '7:30 AM', value: '07:30:00' },
                  { label: '8:00 AM', value: '08:00:00' },
                  { label: '8:30 AM', value: '08:30:00' },
                  { label: '9:00 AM', value: '09:00:00' },
                  { label: '9:30 AM', value: '09:30:00' },
                  { label: '10:00 AM', value: '10:00:00' },
                  { label: '10:30 AM', value: '10:30:00' },
                  { label: '11:00 AM', value: '11:00:00' },
                  { label: '11:30 AM', value: '11:30:00' },
                  { label: '12:00 PM', value: '12:00:00' },
                  { label: '12:30 PM', value: '12:30:00' },
                  { label: '1:00 PM', value: '13:00:00' },
                  { label: '1:30 PM', value: '13:30:00' },
                  { label: '2:00 PM', value: '14:00:00' },
                  { label: '2:30 PM', value: '14:30:00' },
                  { label: '3:00 PM', value: '15:00:00' },
                  { label: '3:30 PM', value: '15:30:00' },
                  { label: '4:00 PM', value: '16:00:00' },
                  { label: '4:30 PM', value: '16:30:00' },
                  { label: '5:00 PM', value: '17:00:00' },
                  { label: '5:30 PM', value: '17:30:00' },
                  { label: '6:00 PM', value: '18:00:00' },
                  { label: '6:30 PM', value: '18:30:00' },
                  { label: '7:00 PM', value: '19:00:00' },
                  { label: '7:30 PM', value: '19:30:00' },
                  { label: '8:00 PM', value: '20:00:00' },
                  { label: '8:30 PM', value: '20:30:00' },
                  { label: '9:00 PM', value: '21:00:00' },
                  { label: '9:30 PM', value: '21:30:00' },
                  { label: '10:00 PM', value: '22:00:00' },
                  { label: '10:30 PM', value: '22:30:00' },
                  { label: '11:00 PM', value: '23:00:00' },
                  { label: '11:30 PM', value: '23:30:00' },
                  { label: '12:00 AM (next day)', value: '00:00:00' },
                  { label: '12:30 AM (next day)', value: '00:30:00' },
                  { label: '1:00 AM (next day)', value: '01:00:00' },
                  { label: '1:30 AM (next day)', value: '01:30:00' },
                  { label: '2:00 AM (next day)', value: '02:00:00' },
                  { label: '2:30 AM (next day)', value: '02:30:00' }
                ],
                mapping: 'StartTime'
              },
              {
                type: 'multiple-choice',
                size: 'Medium',
                label: 'Time Event Ends:*',
                options: [
                  { label: '7:30 AM', value: '07:30:00' },
                  { label: '8:00 AM', value: '08:00:00' },
                  { label: '8:30 AM', value: '08:30:00' },
                  { label: '9:00 AM', value: '09:00:00' },
                  { label: '9:30 AM', value: '09:30:00' },
                  { label: '10:00 AM', value: '10:00:00' },
                  { label: '10:30 AM', value: '10:30:00' },
                  { label: '11:00 AM', value: '11:00:00' },
                  { label: '11:30 AM', value: '11:30:00' },
                  { label: '12:00 PM', value: '12:00:00' },
                  { label: '12:30 PM', value: '12:30:00' },
                  { label: '1:00 PM', value: '13:00:00' },
                  { label: '1:30 PM', value: '13:30:00' },
                  { label: '2:00 PM', value: '14:00:00' },
                  { label: '2:30 PM', value: '14:30:00' },
                  { label: '3:00 PM', value: '15:00:00' },
                  { label: '3:30 PM', value: '15:30:00' },
                  { label: '4:00 PM', value: '16:00:00' },
                  { label: '4:30 PM', value: '16:30:00' },
                  { label: '5:00 PM', value: '17:00:00' },
                  { label: '5:30 PM', value: '17:30:00' },
                  { label: '6:00 PM', value: '18:00:00' },
                  { label: '6:30 PM', value: '18:30:00' },
                  { label: '7:00 PM', value: '19:00:00' },
                  { label: '7:30 PM', value: '19:30:00' },
                  { label: '8:00 PM', value: '20:00:00' },
                  { label: '8:30 PM', value: '20:30:00' },
                  { label: '9:00 PM', value: '21:00:00' },
                  { label: '9:30 PM', value: '21:30:00' },
                  { label: '10:00 PM', value: '22:00:00' },
                  { label: '10:30 PM', value: '22:30:00' },
                  { label: '11:00 PM', value: '23:00:00' },
                  { label: '11:30 PM', value: '23:30:00' },
                  { label: '12:00 AM (next day)', value: '00:00:00' },
                  { label: '12:30 AM (next day)', value: '00:30:00' },
                  { label: '1:00 AM (next day)', value: '01:00:00' },
                  { label: '1:30 AM (next day)', value: '01:30:00' },
                  { label: '2:00 AM (next day)', value: '02:00:00' },
                  { label: '2:30 AM (next day)', value: '02:30:00' }
                ],
                mapping: 'EndTime'
              }
            ]
          },
            {
                fields: [
                    {
                    type: 'text',
                    size: 'Medium',
                    label: 'Number of Guests:*',
                    mapping: 'PlannedGuestCount'
                }
            ]
            },
            {
                fields: [
                  {
                    type: 'multiple-choice',
                    size: 'Medium',
                    label: 'Type of Event:*',
                    options: [
                        { label: 'Social Event', value: 'Social Event' },
                        { label: 'Corporate Event', value: 'Corporate Event' },
                        { label: 'All-day Event', value: 'All-day Event' },
                        { label: 'Breakfast', value: 'Breakfast' },
                        { label: 'Lunch', value: 'Lunch' },
                        { label: 'Dinner', value: 'Dinner' },
                        { label: 'Party', value: 'Party' },
                        { label: 'Other', value: 'Other' },  
                    ],
                    mapping: 'Category'
                }
            ]
            },
            {
                fields: [
                  {
                    type: 'text',
                    size: 'Medium',
                    label: 'Onsite Contact Name:*',
                    mapping: 'EventExtra1'
                }
            ]
            },
            {
                fields: [
                  {
                    type: 'text',
                    size: 'Medium',
                    label: 'Onsite Contact Phone:',
                    mapping: 'EventExtra2'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'text',
                    size: 'Medium',
                    label: 'Name of Location:*',
                    mapping: 'SiteName'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'text',
                    size: 'Medium',
                    label: 'Site Address:*',
                    mapping: 'SiteAddress'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'text',
                    size: 'Medium',
                    label: 'Site City:*',
                    mapping: 'SiteCity'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'text',
                    size: 'Medium',
                    label: 'Site State:*',
                    mapping: 'SiteState'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'text',
                    size: 'Medium',
                    label: 'Site Postal:*',
                    mapping: 'SitePostal'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'text',
                    size: 'Medium',
                    label: 'Desired Food Selections:*',
                    mapping: 'EventExtra3'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'text',
                    size: 'Medium',
                    label: 'Desired Beverage:',
                    mapping: 'EventExtra4'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'text',
                    size: 'Medium',
                    label: 'Overview of Event:*',
                    mapping: 'EventExtra5'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'text',
                    size: 'Medium',
                    label: 'Table and service wares (paper plates, napkins, serving utensils, etc.):*',
                    mapping: 'EventExtra6'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'text',
                    size: 'Medium',
                    label: 'Allergies or special dietary restrictions:*',
                    mapping: 'EventExtra7'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'text-area',
                    size: 'Medium',
                    label: 'Please provide any additional information:',
                    mapping: 'Notes'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'submit',
                    size: 'XLarge',
                    label: 'Submit'
                }
            ]
            }
        ]
    },
    info: {
        title: 'Elephant\'s Deli Contact Form',
        formId: '1876',
        clientKey: '24E4B8D2-1D03-4ECF-812E-069018763A68',
        appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
        redirectUrl: '',
        submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
        apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
    }
};


export default FormStructure;